module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00416.75fdd0ca.jpg";